import { render, staticRenderFns } from "./upload-slide.vue?vue&type=template&id=a568a4c2&scoped=true&"
import script from "./upload-slide.vue?vue&type=script&lang=js&"
export * from "./upload-slide.vue?vue&type=script&lang=js&"
import style0 from "./upload-slide.vue?vue&type=style&index=0&id=a568a4c2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a568a4c2",
  null
  
)

export default component.exports